import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class LoanAndCreditPaymentAccountType extends Enum {
  key!: string;
  value!: string;

  static AUTO: LoanAndCreditPaymentAccountType = {
    key: 'loan_auto',
    get value() {
      return Lang.t('financialaccount.auto-loan');
    }
  };

  static COMMERCIAL_LOAN: LoanAndCreditPaymentAccountType = {
    key: 'loan_commercial',
    get value() {
      return Lang.t('financialaccount.commercial-loan');
    }
  };

  static CREDIT_PAYPAL: LoanAndCreditPaymentAccountType = {
    key: 'credit_paypal',
    get value() {
      return Lang.t('asset.paypal');
    }
  };

  static CONSTRUCTION_LOAN: LoanAndCreditPaymentAccountType = {
    key: 'loan_construction',
    get value() {
      return Lang.t('financialaccount.construction-loan');
    }
  };

  static CONSUMER_LOAN: LoanAndCreditPaymentAccountType = {
    key: 'loan_consumer',
    get value() {
      return Lang.t('financialaccount.consumer-loan');
    }
  };

  static CREDIT_UNKNOWN: LoanAndCreditPaymentAccountType = {
    key: 'credit_unknown',
    get value() {
      return Lang.t('financialaccount.credit-unknown');
    }
  };

  static CREDIT_CARD: LoanAndCreditPaymentAccountType = {
    key: 'credit_credit_card',
    get value() {
      return Lang.t('financialaccount.credit-card');
    }
  };

  static HOME_EQUITY: LoanAndCreditPaymentAccountType = {
    key: 'loan_home_equity',
    get value() {
      return Lang.t('financialaccount.home-equity-loan');
    }
  };

  static LINE_OF_CREDIT: LoanAndCreditPaymentAccountType = {
    key: 'loan_line_of_credit',
    get value() {
      return Lang.t('financialaccount.line-loan-credit');
    }
  };

  static LOAN_RRSP: LoanAndCreditPaymentAccountType = {
    key: 'loan_rrsp',
    get value() {
      return Lang.t('financialaccount.rrsp-loan');
    }
  };

  static LOAN: LoanAndCreditPaymentAccountType = {
    key: 'loan_loan',
    get value() {
      return Lang.t('financialaccount.loan');
    }
  };

  static MORTGAGE: LoanAndCreditPaymentAccountType = {
    key: 'loan_mortgage',
    get value() {
      return Lang.t('financialaccount.mortgage-loan');
    }
  };

  static OVERDRAFT: LoanAndCreditPaymentAccountType = {
    key: 'loan_overdraft',
    get value() {
      return Lang.t('financialaccount.overdraft-loan');
    }
  };

  static STUDENT_LOAN: LoanAndCreditPaymentAccountType = {
    key: 'loan_student',
    get value() {
      return Lang.t('financialaccount.student-loan');
    }
  };

  static OTHER: LoanAndCreditPaymentAccountType = {
    key: 'loan_other',
    get value() {
      return Lang.t('financialaccount.other-loan');
    }
  };

  static getTypesWithCreditorMailingAddressInCalifornia(): Array<LoanAndCreditPaymentAccountType> {
    return [
      LoanAndCreditPaymentAccountType.AUTO,
      LoanAndCreditPaymentAccountType.COMMERCIAL_LOAN,
      LoanAndCreditPaymentAccountType.CREDIT_PAYPAL,
      LoanAndCreditPaymentAccountType.CONSUMER_LOAN,
      LoanAndCreditPaymentAccountType.CREDIT_CARD,
      LoanAndCreditPaymentAccountType.CREDIT_UNKNOWN,
      LoanAndCreditPaymentAccountType.LINE_OF_CREDIT,
      LoanAndCreditPaymentAccountType.LOAN,
      LoanAndCreditPaymentAccountType.OVERDRAFT,
      LoanAndCreditPaymentAccountType.STUDENT_LOAN,
      LoanAndCreditPaymentAccountType.OTHER
    ];
  }

  static getTypeKeysWithCreditorMailingAddressInCalifornia(): Array<string> {
    return LoanAndCreditPaymentAccountType.getTypesWithCreditorMailingAddressInCalifornia().map(
      (type: LoanAndCreditPaymentAccountType) => type.key
    );
  }
}
